import {MediaConfig} from '../config/media.config';

export const defaultTipTextConfig: MediaConfig = {
  text: true,
  image_url: true,
  audio_url: true,
  avatar_image_url: true,
  widget_type: true,
  with_tts: true,
  language: true,
  text_direction: true,
  has_speech_marks: true,
};
